import { create } from 'zustand';

interface UIState {
    isAuthModalOpen: boolean;
    authModalMode: 'login' | 'register' | 'forgot-password' | 'reset-password';
    recoveryToken: string | null;
    // Acciones
    openAuthModal: (mode?: 'login' | 'register' | 'forgot-password' | 'reset-password', token?: string) => void;
    closeAuthModal: () => void;
    setAuthModalMode: (mode: 'login' | 'register' | 'forgot-password' | 'reset-password') => void;
    setRecoveryToken: (token: string | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
    isAuthModalOpen: false,
    authModalMode: 'login',
    recoveryToken: null,

    openAuthModal: (mode = 'login', token) => 
        set({ isAuthModalOpen: true, authModalMode: mode, recoveryToken: token || null }),
    closeAuthModal: () => set({ isAuthModalOpen: false, recoveryToken: null }),
    setAuthModalMode: (mode) => set({ authModalMode: mode }),
    setRecoveryToken: (token) => set({ recoveryToken: token }),
}));
